import { SidePanelSide } from 'designSystem/components/sidePanelContext'
import { cn } from 'designSystem/lib/utils'
import type { KeyboardEvent, PointerEvent } from 'react'

export function SidePanelResizeHandle({
  maxWidth,
  minWidth,
  onKeyDown,
  onPointerDown,
  side,
  width,
}: {
  maxWidth: number | undefined
  minWidth: number
  onKeyDown: (event: KeyboardEvent<HTMLDivElement>) => void
  onPointerDown: (event: PointerEvent<HTMLDivElement>) => void
  side: SidePanelSide
  width: number
}) {
  return (
    <div
      data-slot='side-panel-resize-handle'
      role='separator'
      aria-orientation='vertical'
      aria-label='Resize panel'
      aria-valuenow={Math.round(width)}
      aria-valuemin={minWidth}
      aria-valuemax={maxWidth}
      tabIndex={0}
      className={cn(
        'group absolute top-0 z-10 flex h-full w-3 cursor-col-resize touch-none items-center justify-center',
        'focus:outline-none',
        side === SidePanelSide.Right ? '-left-1.5' : '-right-1.5'
      )}
      onPointerDown={onPointerDown}
      onKeyDown={onKeyDown}>
      <div
        className={cn(
          'h-full w-px bg-transparent transition-colors',
          'group-hover:bg-primary/30 group-active:bg-primary/60',
          'group-focus-visible:bg-primary/60'
        )}
      />
    </div>
  )
}
